import { type UseQueryResult, useQuery } from 'react-query';
import {
  UserDefinedFieldsService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_UserDefinedFieldsListDto,
} from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetUserDefinedFieldsList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_UserDefinedFieldsListDto | undefined,
  unknown
> => {
  const { moduleId, statusId, filter, sorting, skipCount, maxResultCount, _force } = tableInfo;
  const userDefinedFieldsList = useQuery(
    [
      'getUserDefinedFieldsList',
      moduleId,
      statusId,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        UserDefinedFieldsService.getApiCustomerApiAppUserDefinedFieldsUserDefinedFieldsList(
          moduleId,
          statusId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return userDefinedFieldsList;
};

export default useGetUserDefinedFieldsList;
